export const BoxItemForm = {
  model: 'BoxItem',
  format: [
    {
      widths: 'equal',
      fields: {
        display_name: {
          type: 'text',
          required: true,
        },
        description: {
          type: 'text',
          required: true,
        },
        box_item: {
          type: 'dropdown',
          label: 'Type',
          required: true,
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        content_type: {
          type: 'dropdown',
          required: true,
        },
      },
    },
    {
      html: 'Make sure to follow <a href="https://doc.courtbouillon.org/weasyprint/stable/">Weasyprint</a> standards in your HTML/CSS templates and <a href="https://www.markdownguide.org/basic-syntax/">Markdown Syntax</a> for Markdown templates.',
      fields: {},
    },
    {
      widths: 'equal',
      fields: {
        content: {
          type: 'code',
          style: {
            height: '700px',
          },
        },
      },
    },
    {
      widths: 'equal',
      fields: {
        css: {
          type: 'code',
          style: {
            height: '700px',
          },
        },
      },
    },
  ],
}
